export function countBgColor(count) {
  if (count === 0 || count === null) {
    return 'rgba(241, 13, 41, 0.22)';
  } else {
    return 'transparent'
  }
}